export default {
    methods: {
        closePop(key) {
            this[key] = false;
        },
        showPop(key) {
            this[key] = true;
        },
        switchPop(key1,key2){
            this[key1]=false;
            this[key2]=true;
        }
    }
}